require('./bootstrap');

import { createApp } from 'vue';
import App from './App.vue';
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import moment from 'moment';
import router from './router';

import globalComponents from './globals/globalComponents.js';
import { globalVariables }  from './globals/globalVariables.js';
// import { globalFunctions }  from './globals/globalFunctions.js';
import { useGlobalFunctions } from './globals/globalFunctions.js';

import store from "./store/store";

import Notifications from '@kyvg/vue3-notification';
import {LoadingPlugin} from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import DropdownCustom from "./components/DropdownCustom/index";
import PopupCustom from "./components/PopupCustom/index";

import { directive as vTippy } from 'vue-tippy';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';

// import Vuesax from 'vuesax3';
/* import 'vuesax3/dist/vuesax.css'; */

const app = createApp(App);
app.use(router);
app.use(VueSweetalert2);
app.use(store);
app.use(Notifications);
app.use(LoadingPlugin);
app.use(DropdownCustom);
app.use(PopupCustom);
// app.use(Vuesax);

globalComponents.forEach((component) => {
    app.component(component.name, component);
});
app.component('v-select', vSelect);

app.config.globalProperties.$globalVariables = globalVariables;
app.config.globalProperties.$moment=moment;
const globalFunctions = useGlobalFunctions();
app.config.globalProperties.$globalFunctions  = globalFunctions;

app.directive('tippy', vTippy);

app.mount('#app');